<template>
  <!--
    Code By     : 陈伦刚
    CreateTime  : 2020-12-14 01:36:00
    Description :
  -->
  <div class="main page">
    <!-- <div class="box"></div> -->
    <div class="header">
      <div class="left">素材 (模板)</div>
      <div class="right">
        <div class="return" @click="goBack">
          <return theme="outline" />
          取消
        </div>
      </div>
    </div>
    <p class="statement">
      Gaiamount禁止发布任何违反相关法律法规的内容，您需确认拥有所提交内容的相关版权许可；付费素材投稿的请认真阅读Gaiamount
      相关分成条款与协议
    </p>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      status-icon
      label-position="top"
    >
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="基础信息" prop="info">
        <div class="input-group">
          <el-input v-model="form.version" placeholder="推荐软件"></el-input>
        </div>
      </el-form-item>
      <el-form-item label="下载设置" prop="allowDownload">
        <el-select
          v-model="form.allowDownload"
          placeholder="请选择"
          style="width: 100%"
          @change="allowDownloadChange"
        >
          <el-option label="免费下载" :value="false"> </el-option>
          <el-option label="付费下载" :value="true"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="捐赠设置" prop="acceptDonations">
        <el-select
          v-model="form.acceptDonations"
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option label="不接受捐赠" :value="false"> </el-option>
          <el-option label="接受捐赠" :value="true"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.allowDownload">
        <div class="price-box">
          <div class="item">
            <span class="title" style="margin-right: 28px">原价：</span>
            <span>源文件：{{ form.firstPrice }}元</span>
          </div>
          <div class="item">
            <span class="title" style="margin-right: 14px">折扣价：</span>
            <span>源文件：{{ form.discountPrice }}元</span>
          </div>
          <div class="item">
            <span class="title">专业用户：</span>
            <span>源文件：{{ form.disProPrice }}元</span>
          </div>
          <div class="item">
            <span class="title">高级用户：</span>
            <span>源文件：{{ form.disAdvPrice }}元</span>
          </div>
          <div class="item">
            <span class="title">商业用户：</span>
            <span>源文件：{{ form.disBnsPrice }}元</span>
          </div>
          <div class="item">
            <span class="title">折扣时间：</span>
            <span>{{ form.time[0] }}</span>
          </div>
          <div class="setting" @click="dialogVisible = true">
            <i class="el-icon-edit-outline"></i>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="分类标签" prop="keyword">
        <el-input
          v-model="form.keyword"
          :readonly="true"
          @focus="tagSelectVisible = true"
        ></el-input>
        <tag-select
          v-model="tagSelectVisible"
          :tags="form.keyword"
          :tagsList="tagsList"
          @change="
            (tags) => {
              form.keyword = tags;
            }
          "
        />
      </el-form-item>
      <el-divider></el-divider>

      <el-form-item label="封面视频（900*506px）" prop="cover">
        <!-- <upload-cover :src="form.videoId" @change="coverChange" /> -->
        <upload-videoCover v-model="form.videoId" :formatList="formatList2">
          <el-button type="primary">
            {{ !form.videoId ? "开始上传" : "重新上传" }}
          </el-button>
        </upload-videoCover>
      </el-form-item>
      <el-form-item label="幕后故事">
        <gaia-editor v-model="form.story" />
      </el-form-item>
      <el-form-item>
        <div class="info-box">
          <div class="item">
            <div class="name">
              <span>人像授权协议 </span>
              <question-prompt
                content="当您的素材中涉及肖像权及物权内容时，请上传肖像权及物权授权协议，可以PDF、JPG或文档格式提交。"
              />
            </div>
            <div class="box">
              <div>
                <upload-file
                  v-model="form.PoAgreementId"
                  type="po"
                  format="image/jpeg,application/pdf,application/msword"
                >
                  <i class="el-icon-plus"></i>
                  <span>{{
                    !form.PoAgreementId ? "选择协议" : "重新选择"
                  }}</span>
                </upload-file>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="name">
              <span>物权授权协议</span>
              <question-prompt
                content="当您的素材中涉及肖像权及物权内容时，请上传肖像权及物权授权协议，可以PDF、JPG或文档格式提交。"
              />
            </div>
            <div class="box">
              <upload-file
                v-model="form.ReAgreementId"
                type="re"
                format="image/jpeg,application/pdf,application/msword"
              >
                <i class="el-icon-plus"></i>
                <span>{{ !form.ReAgreementId ? "选择协议" : "重新选择" }}</span>
              </upload-file>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="access"> 上传即表示您已同意网站 </el-checkbox>
        <a
          class="pact"
          href="https://gaiamount.com/desktop/richPage?type=2"
          target="_blank"
        >
          《上传协议》
        </a>
      </el-form-item>
      <el-form-item>
        <el-button
          :disabled="!access"
          :loading="applyLoading"
          type="primary"
          @click="update"
          style="width: 100%"
        >
          应用
        </el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      :title="`下载付费设置`"
      :visible.sync="dialogVisible"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="600px"
    >
      <div class="video-price-setting">
        <div class="explain">
          原价（＞0元）＞折扣价＞会员折扣价【专业用户≥高级用户≥商业用户价格，源文件价＞<br />
          转码文件价＞下转码文件价（多个下转码文件价格可以相同）。未设置折扣价时仍可设置<br />
          会员折扣价】;<br />
          折扣价/会员折扣价为“0”时代表限时免费，必须设置折扣时间（折扣价为“0”时无法设<br />
          置会员折扣价）; 折扣时间到期后自动恢复原价。<br />
        </div>
        <div style="color: #ff5b67; font-size: 14px">○ 原价</div>
        <div class="price-item">
          <el-input
            maxlength="7"
            type="number"
            placeholder="源文件"
            v-model="form.firstPrice"
            @change="priceMoreThan"
            @focus="$event.currentTarget.select()"
            size="mini"
          >
            <span slot="suffix" class="el-input__icon">元</span>
          </el-input>
        </div>
        <div>
          <el-checkbox v-model="form.haveSetDisPrice">折扣价</el-checkbox>
        </div>
        <div class="price-item">
          <el-input
            maxlength="7"
            type="number"
            :disabled="!form.haveSetDisPrice"
            placeholder="源文件"
            v-model="form.discountPrice"
            @change="priceMoreThan"
            @focus="$event.currentTarget.select()"
            size="mini"
          >
            <span slot="suffix" class="el-input__icon">元</span>
          </el-input>
        </div>
        <el-checkbox v-model="form.haveSetMemDisPrice">会员折扣价</el-checkbox>
        <div class="price-item">
          <el-input
            maxlength="7"
            type="number"
            :disabled="!form.haveSetMemDisPrice"
            placeholder="源文件"
            v-model="form.disProPrice"
            @change="priceMoreThan"
            @focus="$event.currentTarget.select()"
            size="mini"
          >
            <span slot="suffix" class="el-input__icon">元</span>
          </el-input>
          <span class="tag" style="color: #ff962c">(PRO)</span>
        </div>
        <div class="price-item">
          <el-input
            maxlength="7"
            type="number"
            :disabled="!form.haveSetMemDisPrice"
            placeholder="源文件"
            v-model="form.disAdvPrice"
            @change="priceMoreThan"
            @focus="$event.currentTarget.select()"
            size="mini"
          >
            <span slot="suffix" class="el-input__icon">元</span>
          </el-input>
          <span class="tag" style="color: #fb4e54">(ADV)</span>
        </div>
        <div class="price-item">
          <el-input
            maxlength="7"
            type="number"
            :disabled="!form.haveSetMemDisPrice"
            placeholder="源文件"
            v-model="form.disBnsPrice"
            @change="priceMoreThan"
            @focus="$event.currentTarget.select()"
            size="mini"
          >
            <span slot="suffix" class="el-input__icon">元</span>
          </el-input>
          <span class="tag" style="color: #706cd1">(BNS)</span>
        </div>
        <el-checkbox v-model="form.haveSetTime">折扣时间</el-checkbox>
        <div class="price-item">
          <el-date-picker
            :disabled="!form.haveSetTime"
            v-model="form.time"
            size="mini"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          style="width: 100%"
          @click="priceSettingConfirm"
        >
          保存
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getMaterialTags,
  getOwnMaterialTags,
  getUpdateMaterial,
  updateTemplateMaterial,
} from "@/api/material";
import UploadCover from "@/components/upload/upload-cover";
import UploadVideoCover from "@/components/upload/upload-videoCover";
import QuestionPrompt from "@/components/question-prompt/question-prompt";
import UploadFile from "@/components/upload/upload-file";
import GaiaEditor from "@/components/gaia-editor/gaia-editor";
import { Return } from "@icon-park/vue";
import { checkVerified } from "@/api/upload";
import { compressedList, videoFormatList } from "../upload/format-list";
import tagSelect from "@/components/tag-select/tag-select";
export default {
  components: {
    UploadCover,
    UploadVideoCover,
    QuestionPrompt,
    UploadFile,
    GaiaEditor,
    Return,
    tagSelect,
  },
  data() {
    const info = (rule, value, callback) => {
      if (this.form.model == "") {
        callback(new Error("机型不能为空"));
      } else if (this.form.lens == "") {
        callback(new Error("镜头不能为空"));
      } else if (this.form.address == "") {
        callback(new Error("地点不能为空"));
      } else if (this.form.scene == "") {
        callback(new Error("拍摄不能为空"));
      } else {
        callback();
      }
    };
    const keyword = (rule, value, callback) => {
      if (this.form.keyword.split(";").length < 2) {
        callback(new Error("分类标签至少选择两个"));
      } else {
        callback();
      }
    };
    return {
      tagSelectVisible: false,
      id: "",
      contentType: "template",
      applyLoading: false,
      access: false,
      dialogVisible: false,
      form: {
        acceptDonations: false,
        allowDownload: false,
        title: "",
        version: "",
        cover: "",
        keyword: "",
        story: "",
        PoAgreementId: "",
        ReAgreementId: "",
        haveSetDisPrice: false,
        haveSetMemDisPrice: false,
        haveSetTime: false,
        time: [],
        firstPrice: "", // 原价
        discountPrice: "", // 折扣价
        disProPrice: "", // 专业会员价格
        disAdvPrice: "", // 高级会员
        disBnsPrice: "", // 商业会员
        fileFormat: "",
      },
      rules: {
        title: [
          {
            required: true,
            message: "请输入素材名称",
            trigger: "blur",
          },
          {
            min: 4,
            max: 50,
            message: "长度在 4 到 50 个字符",
            trigger: "change",
          },
        ],
        info: [{ validator: info, trigger: "change", required: true }],
        allowDownload: [{ required: true }],
        keyword: [{ validator: keyword, required: true }],
        acceptDonations: [{ required: true }],
      },
      tagsList: [[], []],
      formatList2: videoFormatList,
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getUpdateMaterial();
    getMaterialTags(4).then((res) => {
      console.log(res);
      this.tagsList[0] = res.materialKeywordList.map((el) => {
        return el.content;
      });
    });
    getOwnMaterialTags(4).then((res) => {
      this.tagsList[1] = res.materialKeywordList.map((el) => {
        return el.content;
      });
    });
  },
  methods: {
    checkVerified() {
      checkVerified().then(({ msg }) => {
        this.msg = msg;
        if (msg === "not.verified") {
          content = "出售付费素材需要实名认证, 是否前往认证？";
        } else if (msg === "waitting") {
          this.$message.warning("认证审核中, 请耐心等待");
        } else if (msg === "notPass") {
          content = "认证未通过, 是否重新认证？";
        }
        if (content) {
          this.$confirm(content)
            .then((_) => {
              this.$router.push("/gaia-material/check-verified");
            })
            .catch((_) => {
              this.form.allowDownload = false;
            });
        }
      });
    },
    allowDownloadChange() {
      if (this.form.allowDownload) {
        this.checkVerified();
      }
    },
    goBack() {
      window.history.go(-1);
    },
    getUpdateMaterial() {
      getUpdateMaterial(this.id)
        .then((res) => {
          const contentType = res.material.contentType;
          const material = res.material;
          if (contentType === "template") {
            this.form = {
              acceptDonations: material.acceptDonations,
              materialId: material.id,
              allowDownload: material.allowDownload,
              cover: material.cover,
              disAdvPrice: material.disAdvPrice,
              disBnsPrice: material.disBnsPrice,
              disProPrice: material.disProPrice,
              discountPrice: material.discountPrice,
              PoAgreementId:
                res.portraitureAgreement && res.portraitureAgreement.id,
              ReAgreementId:
                res.realrightAgreement && res.realrightAgreement.id,
              firstPrice: material.firstPrice,
              haveSetDisPrice: material.haveSetDisPrice,
              haveSetMemDisPrice: material.haveSetMemDisPrice,
              keyword: material.keyword,
              time: res.time || [],
              story: material.story,
              title: material.title,
            };
            this.form.version = material.template.version;
            this.form.firstPrice = (this.form.firstPrice / 100).toFixed(2);
            this.form.discountPrice = (this.form.discountPrice / 100).toFixed(
              2
            );
            this.form.disProPrice = (this.form.disProPrice / 100).toFixed(2);
            this.form.disAdvPrice = (this.form.disAdvPrice / 100).toFixed(2);
            this.form.disBnsPrice = (this.form.disBnsPrice / 100).toFixed(2);
            this.form.videoId = material.video ? material.video.videoId : "";
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("获取素材详情失败");
        });
    },
    update() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (!this.form.allowDownload || this.priceSettingConfirm() === true) {
            const temp = JSON.parse(JSON.stringify(this.form));
            temp.firstPrice = parseInt(temp.firstPrice * 100);
            temp.discountPrice = parseInt(temp.discountPrice * 100);
            temp.disProPrice = parseInt(temp.disProPrice * 100);
            temp.disAdvPrice = parseInt(temp.disAdvPrice * 100);
            temp.disBnsPrice = parseInt(temp.disBnsPrice * 100);
            temp.keyword = temp.keyword.join(";");
            temp.type = this.contentType;
            if (temp.time === null) {
              temp.time = [];
            }
            updateTemplateMaterial(temp)
              .then((res) => {
                console.log(res);
                this.$message.success("应用成功, 请等待审核");
              })
              .catch((err) => {
                console.log(err);
                this.$message.error("应用失败");
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /**
     * 封面改变
     */
    coverChange(cover) {
      this.form.cover = cover;
    },
    /**
     * 价格变化时 约束输入
     */
    priceMoreThan() {
      const form = this.form;
      form.firstPrice = Math.abs(form.firstPrice).toFixed(2);

      if (form.haveSetDisPrice) {
        form.discountPrice = Math.abs(form.discountPrice).toFixed(2);
      }
      if (form.haveSetMemDisPrice) {
        form.disProPrice = Math.abs(form.disProPrice).toFixed(2);
        form.disAdvPrice = Math.abs(form.disAdvPrice).toFixed(2);
        form.disBnsPrice = Math.abs(form.disBnsPrice).toFixed(2);
      }
    },
    /**
     * 保存价格 校验规则
     */
    priceSettingConfirm(form = null) {
      const f = this.form;
      if (f.haveSetDisPrice) {
        if (!f.haveSetTime && Number(f.discountPrice) == 0) {
          this.$message.error("折扣价为0时, 必须设置折扣时间");
          return;
        }
        if (!(Number(f.firstPrice) > Number(f.discountPrice))) {
          this.$message.error(
            "原价与折扣价设置错误, 相同转码分辨率 原价＞折扣价"
          );
          return;
        }
      }
      if (f.haveSetMemDisPrice) {
        if (
          !f.haveSetTime &&
          (Number(f.disProPrice) == 0 ||
            Number(f.disAdvPrice) == 0 ||
            Number(f.disBnsPrice) == 0)
        ) {
          this.$message.error("会员折扣价为0时, 必须设置折扣时间");
          return;
        }
        if (!(Number(f.firstPrice) > Number(f.disProPrice))) {
          this.$message.error("价格设置错误 原价＞会员折扣价");
          return;
        }
        if (!(Number(f.disProPrice) > Number(f.disAdvPrice))) {
          this.$message.error("价格设置错误 PRO会员折扣价≥ADV会员折扣价");
          return;
        }
        if (!(Number(f.disAdvPrice) > Number(f.disBnsPrice))) {
          this.$message.error("价格设置错误 ADV会员折扣价≥BNS会员折扣价");
          return;
        }
      }
      if (
        f.haveSetDisPrice &&
        f.haveSetMemDisPrice &&
        !(Number(f.discountPrice) > Number(f.disProPrice))
      ) {
        this.$message.error("价格设置错误 折扣价＞PRO会员折扣价");
        return;
      }
      if (f.haveSetTime) {
        if (!(Array.isArray(f.time) && f.time.length == 2)) {
          this.$message.error("未设置折扣时间");
          return;
        }
      }
      this.dialogVisible = false;
      return true;
    },
  },
};
</script>
<style lang="less" >
// .index {
//   background: #f2f2f2;
// }
</style>
<style lang="less" scoped>
.main {
  // height: 1600px;
  padding-top: 100px;
  padding: 100px 150px 100px 150px;
  // background: #f2f2f2;
}
.box {
  height: 500px;
  background: #ffffff;
  box-sizing: border-box;
}
.header {
  width: 100%;
  margin: 0 auto;
  background: #e6e6e6;
  border-bottom: 2px solid #e45151;
  .left {
    display: inline-block;
    float: left;
    width: 50%;
    padding: 10px 20px 4px;
    text-align: left;
  }
  .right {
    display: inline-block;
    width: 50%;
    padding: 10px 20px 4px;
    text-align: right;
    .return {
      float: right;
      width: 100px;
      text-align: right;
      user-select: none;
      cursor: pointer;
    }
  }
}

.statement {
  font-size: 12px;
  color: #b2b2b3;
  margin: 20px 0px;
}

.input-group {
  div {
    // width: 22.3%;
    margin: 0 0 6px 3.5%;
  }
  div:nth-child(4n + 1) {
    margin-left: 0;
  }
}

.info-box {
  display: flex;
  .item {
    width: 22%;
  }
  .name {
  }
  .box {
    height: 40px;
    font-size: 12px;
    margin-right: 20px;
    padding-left: 10px;
    color: #909399;
    border: 1px solid #dcdcdc;
    cursor: pointer;
  }
}
.price-box {
  width: 100%;
  height: 228px;
  padding: 0 20px;
  background: #f5f5f5;
  border: 1px solid #f2f2f2;
  border-radius: 4px;
  .item {
    height: 30px;
    font-size: 14px;
    color: #999999;
    .title {
      color: #333333;
    }
  }
  .setting {
    position: relative;
    left: 800px;
    top: -120px;
    width: 52px;
    height: 52px;
    border-radius: 50%;
    padding-top: 6px;
    font-size: 18px;
    text-align: center;
    color: #1f7ee5;
    background: #dfeeff;
    user-select: none;
    cursor: pointer;
  }
}
.video-price-setting {
  .price-item {
    margin: 10px 0 20px;
    font-size: 14px;
    .tag {
      font-size: 12px;
    }
    .el-input {
      width: 16%;
      margin-right: 2.5%;
    }
    .el-input:last-child {
      margin-right: 0;
    }
  }
}
</style>
